module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-side"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "vmenu"
  }, [_c('div', {
    staticClass: "link first top",
    staticStyle: {
      "margin": "60px 0 4px 0"
    }
  }, [_vm._v("ABOUT US")]), _vm._v(" "), _c('router-link', {
    staticClass: "_page-team",
    attrs: {
      "to": "/inside/profilo/studio"
    }
  }, [_vm._v("profile")]), _vm._v(" "), _c('router-link', {
    staticClass: "_page-team",
    attrs: {
      "to": "/inside/profilo/team"
    }
  }, [_vm._v("team")]), _vm._v(" "), _c('router-link', {
    staticClass: "_page-team",
    attrs: {
      "to": "/inside/profilo/clienti"
    }
  }, [_vm._v("clients")]), _vm._v(" "), _c('router-link', {
    staticClass: "_page-premi",
    attrs: {
      "to": "/inside/profilo/premi"
    }
  }, [_vm._v("awards")]), _vm._v(" "), _c('router-link', {
    staticClass: "_page-mostre",
    attrs: {
      "to": "/inside/profilo/mostre"
    }
  }, [_vm._v("exhibitions")]), _vm._v(" "), _c('router-link', {
    staticClass: "_page-pubblicazioni",
    attrs: {
      "to": "/inside/profilo/pubblicazioni"
    }
  }, [_vm._v("publications")]), _vm._v(" "), _c('router-link', {
    staticClass: "_page-eventi",
    attrs: {
      "to": "/inside/profilo/eventi"
    }
  }, [_vm._v("events")]), _vm._v(" "), _c('div', {
    staticClass: "link first top"
  }, [_vm._v("PROJECTS")]), _vm._v(" "), _c('router-link', {
    staticClass: "_page-selezione",
    attrs: {
      "to": "/progetti"
    }
  }, [_vm._v("selected")]), _vm._v(" "), _c('el-popover', {
    ref: "temiPop",
    attrs: {
      "placement": "left",
      "width": "140",
      "trigger": "hover"
    },
    model: {
      value: (_vm.temiPopV),
      callback: function($$v) {
        _vm.temiPopV = $$v
      },
      expression: "temiPopV"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/tema/1/interiors"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("interiors")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tema/2/graftings"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("graftings")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tema/3/reuse"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("reuse")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tema/4/relational spaces"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("relational spaces")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tema/5/texture"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("texture")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tema/6/sustainability"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("sustainability")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tema/7/transformation"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("transformation")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "popover",
      rawName: "v-popover:temiPop",
      arg: "temiPop"
    }],
    staticClass: "vmenupop",
    staticStyle: {
      "width": "90px",
      "margin": "0 auto"
    }
  }, [_vm._v("topics")]), _vm._v(" "), (_vm.$route.params.tipologia != '') ? _c('div', {
    staticStyle: {
      "font-size": "1.3rem",
      "color": "#999999"
    }
  }, [_vm._v(_vm._s(_vm.$route.params.tema))]) : _vm._e(), _vm._v(" "), _c('el-popover', {
    ref: "tipologiePop",
    attrs: {
      "placement": "left",
      "width": "140",
      "trigger": "hover",
      "offset": "0"
    },
    model: {
      value: (_vm.tipologiePopV),
      callback: function($$v) {
        _vm.tipologiePopV = $$v
      },
      expression: "tipologiePopV"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/tipologia/1/urban spaces and landscape"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tipologiePopV = false
      }
    }
  }, [_vm._v("urban spaces and landscape")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tipologia/2/public buildings"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tipologiePopV = false
      }
    }
  }, [_vm._v("public buildings")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tipologia/3/offices and commercial spaces"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tipologiePopV = false
      }
    }
  }, [_vm._v("offices and commercial spaces")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tipologia/4/housing"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tipologiePopV = false
      }
    }
  }, [_vm._v("housing")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tipologia/5/cultural projects"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tipologiePopV = false
      }
    }
  }, [_vm._v("cultural projects")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "popover",
      rawName: "v-popover:tipologiePop",
      arg: "tipologiePop"
    }],
    staticClass: "vmenupop",
    staticStyle: {
      "width": "90px",
      "margin": "0 auto"
    }
  }, [_vm._v("types")]), _vm._v(" "), (_vm.$route.params.tipologia != '') ? _c('div', {
    staticStyle: {
      "font-size": "1.3rem",
      "color": "#999999"
    }
  }, [_vm._v(_vm._s(_vm.$route.params.tipologia))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-bottom yo-align-center"
  }, [_c('div', {
    staticClass: "nav-newsletter"
  }, [_vm._m(1), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticStyle: {
      "color": "#666"
    },
    attrs: {
      "to": "/inside/profilo/newsletter-archivio"
    }
  }, [_vm._v("newsletter archive")])], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-lang"
  }, [_c('a', {
    staticClass: "current",
    attrs: {
      "href": "/site"
    }
  }, [_vm._v("it")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("en")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/site/inside/coming/coming"
    }
  }, [_vm._v("fr")])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "first _page-contatti",
    staticStyle: {
      "margin": "4px 0 8px 0",
      "display": "block"
    },
    attrs: {
      "to": "/inside/contatti/contatti"
    }
  }, [_vm._v("contacts")]), _vm._v(" "), _c('router-link', {
    staticClass: "first _page-contatti",
    staticStyle: {
      "margin": "4px 0 8px 0",
      "display": "block"
    },
    attrs: {
      "to": "/inside/contatti/note_legali"
    }
  }, [_vm._v("legal notes")]), _vm._v(" "), _vm._m(2)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "side-title"
    }
  }, [_c('a', {
    attrs: {
      "href": "/site"
    }
  }, [_c('h1', [_vm._v("DAP"), _c('div', [_vm._v("studio")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://d9x0i.emailsp.com/frontend/forms/Subscription.aspx?idList=4&idForm=65&guid=D741F501-C6A8-4BD4-8FFA-6510561937E7",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/site/images/newsletter-iscrizione.png",
      "alt": "Sign up Newsletter",
      "width": "32"
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "link first top"
  }, [_c('strong', [_vm._v("SIGN UP FOR OUR NEWSLETTER")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-social"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://twitter.com/dap_studio"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/twitter.svg"),
      "alt": "Twitter icon"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/pages/DAPstudio-elena-sacco-paolo-danelli/160426864008613"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/facebook.svg"),
      "alt": "Facebook icon"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.instagram.com/paolo_danelli"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/instagram.svg"),
      "alt": "Instagram icon"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-697b21dd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Site-side.vue
// module id = 360
// module chunks = 0